module.exports = __webpack_public_path__ + "img/icon-angle-bot.c32f4120.svg";